export const differenceInDays = (date: Date) => {
  const givenDate = new Date(date);

  const currentDate = new Date();

  const differenceInTime = givenDate.getTime() - currentDate.getTime();

  const differenceInDays = Math.max(
    0,
    Math.floor(differenceInTime / (1000 * 3600 * 24))
  );

  return differenceInDays;
};
